module.exports = __webpack_public_path__ + "img/j_hero.10298481.webp";